/**
 * Brings an element into view for a "jump to" action: scrolls it under the sticky chrome (its
 * `scroll-margin-top`), flashes a gold ring so the eye lands on it, and moves focus there so
 * keyboard and screen-reader users follow. Returns false when the element isn't rendered.
 */
export const revealElement = (id: string): boolean => {
  const el = document.getElementById(id);
  if (!el) return false;
  const reduceMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
  // Tells the phone header not to treat this scroll as the user's (it would hide/show itself).
  window.dispatchEvent(new Event("app:programmatic-scroll"));
  el.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
  if (!el.hasAttribute("tabindex")) el.setAttribute("tabindex", "-1");
  el.focus({ preventScroll: true });
  if (!reduceMotion && typeof el.animate === "function") {
    el.animate(
      [
        { boxShadow: "0 0 0 2px rgba(229, 191, 149, 0.95), 0 0 24px rgba(205, 160, 117, 0.35)" },
        { boxShadow: "0 0 0 2px rgba(229, 191, 149, 0), 0 0 24px rgba(205, 160, 117, 0)" },
      ],
      { duration: 2000, easing: "ease-out" }
    );
  }
  return true;
};
